import React, { useState, useEffect } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import ErrorIcon from "@assets/svg/Error";
import Photo from "./Photo";
import Comment from "./Comment";
import { saveJsonData, removeJson } from "../../utils/commonFunctions";
import metrics from "../../constants/metrics";

import t from "@constants/localization";

const PATH = "screens/KYCSetup/AadharSection";

const AADHAR_NUMBER_REGEX = /[0-9]{12}/;
const AadharSection = (props) => {
  const {
    aadharNumber,
    setAadharNumber,
    aadharFront,
    aadharBack,
    uploadAadharFront,
    uploadAadharBack,
    removeAadharFront,
    removeAadharBack,
    disableAadharSection,
    verified,
    rejectionComment = null,
    testAadharID = "",
  } = props;
  const [unmatched, setUnmatched] = useState(false);

  const { source: frontSource = "" } = aadharFront;
  const { source: backSource = "" } = aadharBack;

  const _onBlur = () => {
    if (aadharNumber && aadharNumber.length) {
      if (AADHAR_NUMBER_REGEX.test(aadharNumber.replace(/\s/g, ""))) {
        saveJsonData("kyc_aadhar_number", aadharNumber);
      } else {
        setUnmatched(true);
        removeJson("kyc_aadhar_number");
      }
    }
  };

  const _onChangeText = (text) => {
    setUnmatched(false);
    setAadharNumber(text);
  };

  const title = disableAadharSection
    ? verified
      ? t(`${PATH}/aadhar`).concat(t(`${PATH}/verified`))
      : t(`${PATH}/aadhar`)
    : t(`${PATH}/aadharNumber`);

  return (
    <View style={{ marginTop: 20 }}>
      <Comment kycComment={rejectionComment} />
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {verified && (
          <CheckIcon
            fill="rgba(0,171,89,1)"
            size={20}
            style={{ marginRight: 5 }}
          />
        )}
        <Text>{title}</Text>
      </View>
      <View style={[styles.textInputWrapper, { position: "relative" }]}>
        <TextInput
          testID={testAadharID}
          editable={!disableAadharSection}
          style={[
            styles.textInput,
            {
              borderColor: unmatched ? "red" : "rgba(0,0,0,0.2)",
              backgroundColor: disableAadharSection
                ? "rgba(0,0,0,0.05)"
                : "white",
            },
          ]}
          placeholder="1234566789012"
          value={aadharNumber}
          maxLength={12}
          onBlur={_onBlur}
          onChangeText={_onChangeText}
          keyboardType="numeric"
        />
        {unmatched && (
          <View
            style={{
              position: "absolute",
              right: 0,
              flexDirection: "row",
              height: "100%",
              alignItems: "center",
              paddingRight: 10,
            }}
          >
            <ErrorIcon />
            <Text style={{ fontSize: 12, color: "red", marginLeft: 4 }}>
              {t(`${PATH}/checkYourAadhar`)}
            </Text>
          </View>
        )}
      </View>
      <View style={styles.aadharPhotosContainer}>
        <View
          style={{
            alignSelf: "flex-start",
            maxWidth: (metrics.screenWidth - 30) / 2,
          }}
        >
          <Photo
            source={frontSource}
            ctaText={t(`${PATH}/frontPhoto`)}
            onUpload={uploadAadharFront}
            onDelete={removeAadharFront}
            style={{ marginRight: 10 }}
            disabled={disableAadharSection}
          />
        </View>

        <View
          style={{
            alignSelf: "flex-start",
            maxWidth: (metrics.screenWidth - 30) / 2,
          }}
        >
          <Photo
            source={backSource}
            ctaText={t(`${PATH}/backPhoto`)}
            onUpload={uploadAadharBack}
            onDelete={removeAadharBack}
            deletable={true}
            disabled={disableAadharSection}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  textInputWrapper: {
    marginTop: 5,
    marginBottom: 10,
  },
  textInput: {
    paddingVertical: 9,
    paddingHorizontal: 15,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    color: "black",
  },
  aadharPhotosContainer: {
    flexDirection: "row",
  },
});

export default AadharSection;
